<script setup lang="ts">
import { toRefs, computed } from 'vue';
import { severitySwitch, getSizeSet, type TagSeverity, type TagSize, type TagContentPosition, type TagBehaviour } from '../../composables/useTagStyles';

const props = defineProps({
  severity: {
    type: String as () => TagSeverity,
    default: 'primary',
  },
  size: {
    type: String as () => TagSize,
    default: 'md',
  },
  label: {
    type: String,
    default: '',
  },
  contentPos: {
    type: String as () => TagContentPosition,
    default: 'left',
  },
  behaviour: {
    type: String as () => TagBehaviour,
    default: 'static',
  },
  icon: {
    type: String,
    default: ''
  },
  iconPos: {
    type: String as () => 'left' | 'right',
    default: 'left',
  },
});

const { severity, size } = toRefs(props);

const severityClasses = computed(() => severitySwitch(severity.value));
const sizeSet = computed(() => getSizeSet(size.value, props.behaviour));
</script>

<template>
  <span
    class="flex rounded-sm font-roboto-slab font-bold gap-1 flex-wrap"
    :class="[
      sizeSet.padding,
      sizeSet.label,
      severityClasses
    ]"
  >
    <template v-if="contentPos === 'left'">
      <slot name="customContent" />
    </template>
    <template v-if="iconPos === 'left'">
      <slot name="icon">
        <i
          v-if="icon !== ''"
          :class="[icon, sizeSet.icon]"
        />
      </slot>
    </template>
    <span>{{ label }}</span>
    <template v-if="iconPos === 'left'">
      <slot name="icon">
        <i
          v-if="icon !== ''"
          :class="[icon, sizeSet.icon]"
        />
      </slot>
    </template>
    <template v-if="contentPos === 'right'">
      <slot name="customContent" />
    </template>
  </span>
</template>
